<template>
  <div class="item item--article item--intro item--article--intro" :class="{'item--major item--article--major': isMajor}">
    <div v-if="item"
         class="inner flex-column gap-l"
         :class="{
      'flex-colum' : !isMajor,
      'l:flex-row' : isMajor,
      'l:gap-2xl' : isMajor
    }"

    >
      <div class="media-block">
        <img
          :src="
               isNonEmptyString(item.thumbnailImage)
                ? item.thumbnailImage
                : item.mainImageUrl
          "
          :alt="t('ag.article.intro.introImageAlt', { title: item.title })" />
      </div>
      <div class="content-block">
        <div class="title">
          <h3 class="text-bold text-l l:text-2xl margin-xs-bottom"
          :class="{'text-overflow-ellipsis': !isMajor}"
          >{{ item.title }}</h3>
        </div>
        <div
          class="meta flex-start width-expand text-start flex-middle flex-center gap-s text-start c-gray-4">
          <span v-if="item.Owner">{{ tt(item?.Owner?.penName) }}</span>
          <span class="c-alt text-xl" style="line-height: 0">&middot;</span>
          <span>{{ translateDate(item.createdAt) }}</span>
          <badge size="s"
                 :theme="item.layout === 'newsFlash' ? 'danger' : 'lead'"
                 >{{ tu('ag.article.fields.layoutPublicBadge.' + item.layout) }}</badge>
        </div>
        <div class="intro-text c-gray-4 margin-m-top">
          <p>
            {{ item.introText }}
          </p>
        </div>
        <div class="cta margin-m-top">
          <saffron-link
            v-slot="{ isActive, href, navigate }"
            :to="{name: 'content-article-articleAlias', params: {articleAlias: item.alias}}">
            <ag-title
              theme="alt-2"
              level="6"
              size="s"
              class="plain-link"
              @click="navigate">
              <icon-text
                class="text-s c-gray-4 gap-none"
                icon-position="end"
                icon="chevron-inline-end"
                >{{ tu("ag.article.readMore") }}</icon-text
              >
            </ag-title>
          </saffron-link>
        </div>
      </div>
    </div>
    <div v-else class="loading flex-middle padding-2xl-vertical flex-center">
      <spinner :size="2"></spinner>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    isMajor: {
      type: Boolean,
      default: false,
    },
    item: {
      type: [Object, Boolean],
      default: false,
    },
  },
  data: function () {
    return {};
  },
  methods: {
    isNonEmptyString(str) {
      return utilities.isNonEmptyString(str);
    }
  }
};
</script>

<style scoped lang="scss">
.item {
  .inner {
    .media-block {
      border-radius: var(--border-radius);
      img {
        width: 100%;
        max-height: 450px; //failsafe
        aspect-ratio: 1.43;
        width: 100%;
        border-radius: var(--border-radius);
      }
    }

    .intro-text p {
      overflow: hidden;
      display: -webkit-box;
      -webkit-line-clamp: 4; /* number of lines to show */
      line-clamp: 4;
      -webkit-box-orient: vertical;
      line-height: 1.8;
    }
  }
}

.item--major {
  .inner {
    .media-block {
      flex:0 0 calc(50% - 0.5 * var(--margin-2xl));
      img {
        width: 100%;
        max-height: 450px; //failsafe
        aspect-ratio: 1.83;
        object-fit: cover;
      }
    }
  }
}
</style>
